import { render, staticRenderFns } from "./v-6.vue?vue&type=template&id=0353665a&scoped=true&"
import script from "./v-6.vue?vue&type=script&lang=js&"
export * from "./v-6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0353665a",
  null
  
)

export default component.exports